import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  radius,
  screen,
  shadow,
  spacing
} from '../../theme';

export const StyledHelp = styled.section`
  text-align: center;
`;

export const StyledIntro = styled.div`
  max-width: ${container('xl')};
  margin: 0 auto ${spacing('xl4')};
  line-height: 1.5;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;

    a {
      font-weight: ${fontWeight('bold')};
    }
  }
`;

export const StyledBlocks = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${spacing('xl')};
  margin-top: ${spacing('lg')};
  margin-bottom: ${spacing('xl4')};
`;

export const StyledBlock = styled.div`
  max-width: 21rem;
  background-color: ${color('white')};
  border-radius: ${radius('md')};
  box-shadow: ${shadow('md')};
  padding: ${spacing('xl')};
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: ${spacing('md')};

  p {
    margin: 0;
    line-height: 1.5;
  }
`;

export const StyledBlockIcon = styled.img`
  display: block;
  width: ${spacing('xl3')};
  height: ${spacing('xl3')};
`;

export const StyledBlockSeparator = styled.div`
  width: ${spacing('xl')};
  height: ${spacing('xs2')};
  background-color: ${color('cyan_700')};
`;

export const StyledBlockTitle = styled.p`
  margin: 0;
  font-size: ${fontSize('lg')};
  font-weight: ${fontWeight('black')};
`;
